import React, { use, useEffect, useState } from "react";

//material ui imports
import {
  Grid,
  TextField,
  Typography,
  Divider,
  Button,
  Stack,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import { useTheme } from "@mui/material/styles";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

//project imports
//import config from "../../../../config";

//third party imports
import * as Yup from "yup";
import { useFormik } from "formik";
//import axios from "axios";
import useAxiosAuth from "../../../../../hooks/useAxiosAuth";

const SubSpecializationForm = (props) => {
  //Constants
  const {
    onSave,
    onCancel,
    selectedCandidateSubSpecializations,
    getCandidateSubSpecializations,
  } = props;
  const axiosAuth = useAxiosAuth();
  const theme = useTheme();
  const pageSize = 1000;
  //States
  const [candidateSpecialization, setCandidateSpecialization] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const formik = useFormik({
    initialValues: {
      id: selectedCandidateSubSpecializations.id,
      candidateSpecializationMasterId:
        selectedCandidateSubSpecializations.candidateSpecializationMasterId,
      name: selectedCandidateSubSpecializations.name,
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .max(50, "Must be 50 characters or less")
        .required("Required"),
    }),

    onSubmit: (values) => {
      setLoading(true);
      if (selectedCandidateSubSpecializations.id === 0) {
        axiosAuth
          .post("/api/CandidateSubSpecizalizationMaster", values)
          .then((response) => {
            if (response.status === 200) {
              onSave();
              getCandidateSubSpecializations();
            } else {
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      } else {
        axiosAuth
          .put("/api/CandidateSubSpecizalizationMaster", values)
          .then((response) => {
            if (response.status === 200) {
              onSave();
              getCandidateSubSpecializations();
            } else {
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      }
    },
  });

  const getCandidateSpecialization = (skip) => {
    axiosAuth
      .get("/api/CandidateSpecializationMasters/list?skip=0&take=" + pageSize)
      .then((response) => {
        setCandidateSpecialization(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getCandidateSpecialization();
  }, [searchText, pageSize]);

  return (
    <>
      <Grid container>
        {selectedCandidateSubSpecializations.id === 0 ? (
          <Stack direction="row" sx={{ marginX: "auto", alignItems: "center" }}>
            <AccountBalanceIcon />

            <Typography
              color={theme.palette.primary.dark}
              variant="h5"
              textAlign="center"
              sx={{ marginLeft: 2 }}
            >
              Add Candidate SubSpecialization
            </Typography>
          </Stack>
        ) : (
          <Stack direction="row" sx={{ marginX: "auto", alignItems: "center" }}>
            <AccountBalanceIcon />
            <Typography
              color={theme.palette.primary.dark}
              variant="h5"
              textAlign="center"
              sx={{ marginLeft: 2 }}
            >
              Edit Candidate SubSpecialization Details
            </Typography>
          </Stack>
        )}
      </Grid>
      <Divider sx={{ marginY: 2 }} />
      <Grid container spacing={3}>
        <Grid item xl={12} lg={12} md={12} sm={12}>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              name="name"
              label="Name*"
              onChange={formik.handleChange}
              value={formik.values.name}
              fullWidth
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              sx={{ marginBottom: 3 }}
            />

            <FormControl sx={{ marginBottom: 3 }} fullWidth>
              <InputLabel>Specialization</InputLabel>
              <Select
                name="candidateSpecializationMasterId"
                label="Specialization"
                onChange={formik.handleChange}
                value={formik.values.candidateSpecializationMasterId}
                error={
                  formik.touched.candidateSpecializationMasterId &&
                  Boolean(formik.errors.candidateSpecializationMasterId)
                }
                helperText={
                  formik.touched.candidateSpecializationMasterId &&
                  formik.errors.candidateSpecializationMasterId
                }
              >
                {candidateSpecialization.map((options) => (
                  <MenuItem value={options.id}>{options.name}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <Divider sx={{ marginBottom: 2 }} />
            <Grid>
              <LoadingButton
                variant="contained"
                type="submit"
                loading={loading}
                loadingPosition="end"
                endIcon={<SaveIcon />}
              >
                Submit
              </LoadingButton>
              <Button
                variant="outlined"
                onClick={onCancel}
                sx={{ marginLeft: 2 }}
              >
                Cancel
              </Button>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </>
  );
};

export default SubSpecializationForm;
